import { deserialize } from 'cerialize'
import { RoleInterfaceElementModel } from 'Pages/interfaceElement'
import { Id } from 'Types/aliases'

export class InterfaceElementModel {
	@deserialize public id: Id
	@deserialize public name: string
	@deserialize public parent_element_id: Id
	@deserialize public kind: string
	@deserialize public slug: string
	@deserialize public order: number
	@deserialize public icon: string
	@deserialize public url: string
	@deserialize public active?: { active: boolean; role_id: Id; roleElemId: Id }
	@deserialize public key?: Id
	public children?: RoleInterfaceElementModel[]
}
